module.exports = __webpack_public_path__ + "img/bannernew.e0e46579.png";